<template>
  <div class="content-attachments-data">
    <f7-block-title
      v-if="showTitle && attachments.length !== 0 "
      class="block-titleColor"
    >
      {{ $t('entityAttachmentsData.title') }}
    </f7-block-title>

    <UCPreload
      :show="isLoadingData"
      :number="1"
    />

    <template v-if="!isLoadingData">
      <div
        v-if="attachments.length === 0"
        class="padding content-no-data"
      >
        {{ $t('entityAttachmentsData.noData') }}
      </div>

      <div v-else>
        <f7-list>
          <f7-list-item
            v-for="(attachment, index) in attachments"
            :key="attachment.Id"
            link="#"
            @click="openAttachment(attachment, openPdfCallback)"
          >
            <div
              v-if="attachment.Nombre"
              class="item-title"
            >
              {{ getAttachmentDescription(attachment, index + 1) }}
            </div>

            <div
              v-else
              class="item-title"
            >
              {{ getAttachmentDescription(attachment, index + 1) }}
            </div>
          </f7-list-item>
        </f7-list>
      </div>
    </template>
  </div>
</template>

<script setup>
// @ts-check
import { onMounted, watch } from 'vue';
import { useEntityAttachmentsData } from '@/composables/useEntityAttachmentsData';

import UCPreload from '@/components/common/UCPreload.vue';

const props = defineProps({
  /** The ID of the entity. */
  entityId: {
    type: Number,
    default: null,
  },
  /** The type of the entity, for example: `PedidoVenta`. */
  entityType: {
    type: String,
    default: null,
  },
  /** Whether to show the title before the list. */
  showTitle: {
    type: Boolean,
    default: true,
  },
  /** Whether to fetch data. */
  isActive: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits([
  'loadingError',
  'openPdf',
]);

const {
  attachments,
  isLoadingData,
  loadAttachmentsData,
  openAttachment,
  getAttachmentDescription,
} = useEntityAttachmentsData();

function openPdfCallback() {
  emit('openPdf');
}

watch(() => props.entityId, (newVal, oldVal) => {
  if (!props.isActive) {
    return;
  }

  if (newVal) {
    loadAttachmentsData(props.entityId, props.entityType).then((result) => {
      if (!result) {
        emit('loadingError');
      }
    });
  }

  if (!newVal && oldVal) {
    attachments.value = [];
  }
});

onMounted(() => {
  if (typeof props.entityId === 'number' && props.isActive) {
    loadAttachmentsData(props.entityId, props.entityType).then((result) => {
      if (!result) {
        emit('loadingError');
      }
    });
  }
});
</script>

<style scoped lang="scss">
.content-attachments-data {
  --f7-list-chevron-icon-color: var(--his-metal-light);
  --f7-list-item-title-text-color: var(--his-oliva);
  --f7-list-item-title-font-size: 14px;

  .content-no-data {
    color: var(--his-oliva);
    font-size: 14px;
  }
}
</style>
